import Entity from "../Entity";

export default class ShowcaseShopItem extends Entity {}
ShowcaseShopItem.addProperties({
	showcaseShopId: Number,
	productId: Number,
});
